var React = require('react');

function Collaboration (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.3,10.3C7.7,9.7,9,9.5,10.2,9.5s2.5,0.3,3.8,0.8c1.3,0.5,2,1.2,2,2.1v1.5H4.4v-1.5C4.4,11.5,5,10.8,6.3,10.3z M3.6,6.5\n\t\th2.2V8H3.6v2.2H2.2V8H0V6.5h2.2V4.4h1.5V6.5z M12.2,7.1C11.7,7.7,11,8,10.2,8s-1.5-0.3-2-0.9c-0.6-0.6-0.9-1.2-0.9-2\n\t\tc0-0.8,0.3-1.5,0.9-2c0.6-0.6,1.2-0.9,2-0.9s1.5,0.3,2,0.9c0.6,0.6,0.9,1.2,0.9,2C13.1,5.9,12.8,6.6,12.2,7.1z","fill":"currentColor"}));
}

Collaboration.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Collaboration;

Collaboration.default = Collaboration;
